import ProgressBarTotalContainer from './ProgressBarTotalContainer';

export default ProgressBarTotalContainer;
